import React,{useEffect,useState} from "react";
import NavBar from "./NavBar";
import Footer from "../component/Footer";
import axios from 'axios'
import NewsDatajson from "../assets/news.json";
import { CircularProgress } from "@material-ui/core";


const AbtStatisticsUI = ()=>{
        const[data, setData] = useState([])
    const[isLoading, setIsLoading] = useState(false)
    useEffect(()=>{
        window.scrollTo(0, 0);
        axios.get('/api/api/stats').then((response)=>{
            console.log("statistics response", response)
            let statsData = [];
        if (response && response.data && response.data.length > 0) {
          response.data.forEach((element) => {
            let index = statsData.findIndex((ele) => ele.statsDate == element.statsDate);
            if (index != -1) {
              statsData[index] = {
                date: element.statsDate,
                stat: [...statsData[index].stat, element],
              };
            } else {
              statsData.push({
                date: element.statsDate,
                stat: [element],
              });
            }
          });
        }
        setData(statsData);
        }).catch((err)=>{
            console.error("statistics error", err)
        })
    },[])

    console.log('data1',data)
    return(<div>
        <NavBar/>
        <main id="main">
    <section class="innerPage">
          <div class="container">
              <div class="section-title">
                  <h2>Statistics</h2>
              </div>
              <div className="row">
              <div className="col-lg-12 d-flex latest">
                {
            isLoading === true ?(
            <div
                    style={{
                      marginTop: "10%",
                      marginLeft: "50%",
                    }}
                  >
                    <CircularProgress
                      variant="indeterminate"
                      value={100}
                      size={50}
                      color={"inherit"}
                    />
                  </div>):(
                     <ul>
                     {data &&
                       data.map((element, index) => (
                        
                         <div>
                           <li className="news-date">{element.date}</li>
                          
                           
                           {element &&
                             element.stat &&
                             element.stat.map((ele, index) => {
                              
                               return (
                                 <li>
                                   <i className="ri-file-pdf-line"></i>{" "}
                                   <a href={ele.fileURL} target="_blank">
                                     {ele.statsDisplayText}
                                   </a>
                                 </li>
                               );
                             })}
                         </div>
                       ))}
                   </ul>
                  )
            }</div>
            </div>
          </div>
      </section>
    </main>
    <Footer footerClass="footerFixed" />
    </div>)
}

export default AbtStatisticsUI